import calculateMinimumSelectedDays from './calculateMinimumSelectedDays';

const getEarliestBookingStartDate = (startDate: string, minimumDate?: string) =>
  startDate || minimumDate;

export default (
  startDate: string,
  minimalPeriod: number,
  listingFlexibleDays: number,
  minimumDate?: string,
): number =>
  calculateMinimumSelectedDays(
    getEarliestBookingStartDate(startDate, minimumDate) || '',
    minimalPeriod,
    listingFlexibleDays,
  );
